import { render } from "./salesReport.vue?vue&type=template&id=1cab2e1e"
import script from "./salesReport.vue?vue&type=script&lang=js"
export * from "./salesReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__